import showToaster from '../../helpers/showToaster';
import { updateListingPriorityMutation } from '../../lib/graphql';

export function updateListingPriority(id, priority) {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation: updateListingPriorityMutation,
                variables: { id, priority }
            });

            if (data?.updateListingPriority?.status === "200") {
                showToaster({ messageId: 'updateSuccess', toasterType: 'success' });
                return { status: 200 };
            } else {
                showToaster({ messageId: 'updateFailed', toasterType: 'error' });
                return { status: 'failed' };
            }
        } catch (error) {
            showToaster({ messageId: 'updateFailed', toasterType: 'error' });
            return { status: 'failed' };
        }
    };
}
